var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHongKong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6519 12.5348C17.2883 14.0473 16.6422 13.7588 16.3251 15.0778C14.4575 14.6288 13.3072 12.7506 13.7563 10.8828C14.2051 9.01515 16.0835 7.8649 17.9512 8.31396C17.317 10.9519 17.9772 11.1821 17.6519 12.5348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8054 13.6558C14.1315 14.4689 13.6575 14.9943 14.8139 15.7035C13.8096 17.3411 11.6681 17.8545 10.0304 16.8503C8.39288 15.8461 7.87932 13.7045 8.88357 12.0669C11.1964 13.4851 11.6193 12.9285 12.8054 13.6558Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3741 18.6114C13.5573 17.6015 13.9103 18.2146 14.9422 17.334C16.1893 18.795 16.0158 20.9905 14.5548 22.2377C13.0937 23.4849 10.8982 23.3112 9.65121 21.8503C11.7146 20.0889 11.3158 19.5145 12.3741 18.6114Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9534 20.5536C16.3584 19.1162 17.0506 18.9697 16.532 17.7164C18.3069 16.9819 20.3414 17.8252 21.076 19.6002C21.8106 21.3751 20.9671 23.4096 19.1921 24.1442C18.1548 21.6374 17.4855 21.8392 16.9534 20.5536Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2152 16.7977C18.6644 16.9194 18.7388 16.2156 17.3866 16.3218C17.2365 14.4068 18.6673 12.7324 20.5824 12.5821C22.4974 12.4321 24.1718 13.8629 24.3219 15.778C21.6171 15.9901 21.6021 16.689 20.2152 16.7977Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHongKong);
export default __webpack_public_path__ + "static/media/flag_hong_kong.d4e2cf05dc7d8eefac49c37c9e2ae68e.svg";
export { ForwardRef as ReactComponent };